import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/Sonner';
import { Layout } from './components/Layout';
import { ScrollToTop } from './components/ScrollToTop';
// Pages
import { Home } from './pages/Home';
import { CFA } from './pages/CFA';
import { BDE } from './pages/BDE';
import { FormationsList } from './pages/FormationsList';
import { FormationDetail } from './pages/FormationDetail';
import { Catalogue } from './pages/Catalogue';
import { Candidater } from './pages/Candidater';
import { Entreprises } from './pages/Entreprises';
import { Qualite } from './pages/Qualite';
import { Accessibilite } from './pages/Accessibilite';
import { Documents } from './pages/Documents';
import { Reclamations } from './pages/Reclamations';
import { Contact } from './pages/Contact';
import { MentionsLegales, Confidentialite, CGV } from './pages/LegalPages';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <Routes data-id="element-2">
        <Route path="/" element={<Layout data-id="element-4" />} data-id="element-3">
          <Route index element={<Home data-id="element-6" />} data-id="element-5" />
          <Route path="le-cfa" element={<CFA data-id="element-8" />} data-id="element-7" />
          <Route path="bde" element={<BDE data-id="element-10" />} data-id="element-9" />
          <Route path="formations" element={<FormationsList data-id="element-12" />} data-id="element-11" />
          <Route path="formations/:id" element={<FormationDetail data-id="element-14" />} data-id="element-13" />
          <Route path="catalogue" element={<Catalogue data-id="element-16" />} data-id="element-15" />
          <Route path="candidater" element={<Candidater data-id="element-18" />} data-id="element-17" />
          <Route path="entreprises" element={<Entreprises data-id="element-20" />} data-id="element-19" />
          <Route path="qualite" element={<Qualite data-id="element-22" />} data-id="element-21" />
          <Route path="accessibilite" element={<Accessibilite data-id="element-24" />} data-id="element-23" />
          <Route path="documents" element={<Documents data-id="element-26" />} data-id="element-25" />
          <Route path="reclamations" element={<Reclamations data-id="element-28" />} data-id="element-27" />
          <Route path="contact" element={<Contact data-id="element-30" />} data-id="element-29" />
          <Route path="mentions-legales" element={<MentionsLegales data-id="element-32" />} data-id="element-31" />
          <Route path="confidentialite" element={<Confidentialite data-id="element-34" />} data-id="element-33" />
          <Route path="cgv" element={<CGV data-id="element-36" />} data-id="element-35" />
        </Route>
      </Routes>
      <Toaster position="bottom-right" data-id="element-37" />
    </BrowserRouter>;
}